var Model = require('../Model');

var incidentsPerShiftReport = Object.create(Model);

incidentsPerShiftReport.name = 'SystemReport';
incidentsPerShiftReport['@class'] = 'SystemFolder';
incidentsPerShiftReport.url = 'systemreportfolder';
incidentsPerShiftReport.fields = {
  startDate: {
    type: 'date',
    validators: {
      presence: true
    }
  },
  endDate: {
    type: 'date',
    validators: {
      presence: true
    }
  },
  groups: {
    default: []
  }
};


module.exports = incidentsPerShiftReport;
